module.exports = __webpack_public_path__ + "src/assets/img/page9/3c4270ca5d12bbe5be185ae201e3ad7f.jpg";